import {createStore,combineReducers} from 'redux';
 
 
import customizationReducer from '../Redux/Reducer/BackboneReducer';
import snackbarReducer from '../Redux/Reducer/SnackbarReducer';
 

const reducer = combineReducers({
    customization: customizationReducer,
    snackbar: snackbarReducer
});

const store = createStore(reducer)

export default store;
export type RootReduxState = ReturnType<typeof reducer>